import * as React from "react";
import type { SVGProps } from "react";
const SvgX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.707 6.707a1 1 0 0 0-1.414-1.414zM5.293 17.293a1 1 0 1 0 1.414 1.414zm1.414-12a1 1 0 0 0-1.414 1.414zm10.586 13.414a1 1 0 0 0 1.414-1.414zm0-13.414-12 12 1.414 1.414 12-12zm-12 1.414 12 12 1.414-1.414-12-12z"
    />
  </svg>
);
export default SvgX;
